import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  Link,
  Typography,
} from '@one-thd/sui-atomic-components';

interface LORPTextOptInTermsDrawerProps {
  open: boolean;
  onClose: () => void;
}

export const LORPTextOptInTermsDrawer = ({
  open,
  onClose,
}: LORPTextOptInTermsDrawerProps) => {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      position="right"
      className="drawer-z-index-fix"
    >
      <DrawerHeader title="Communication Details" onClose={onClose} />
      <DrawerBody>
        <div
          className="sui-flex sui-flex-col sui-gap-4 sui-mb-8"
          data-testid="pickup-text-opt-in-drawer"
        >
          <Typography variant="body-sm">
            By checking the box, you consent to The Home Depot and its
            authorized vendors contacting you at the number provided, including
            by automated technology, SMS/MMS, and/or prerecorded, or artificial
            voice messages. Messages are recurring. Message and data rates may
            apply, and texts may be sent between the hours of [8:00 am and 9:00
            pm].
          </Typography>
          <Typography variant="body-sm">
            Consent is not a condition of purchase, and you may opt out of this
            texting program any time by replying STOP. You also agree to the
            Privacy and Security Statement at{' '}
            <Link
              variant="body-sm"
              href="https://www.homedepot.com/privacy/privacy-and-security-statement"
              target="_blank"
            >
              https://www.homedepot.com/privacy/privacy-and-security-statement
            </Link>{' '}
            and the Terms of Use at{' '}
            <Link
              variant="body-sm"
              href="https://www.homedepot.com/c/Terms_of_Use"
              target="_blank"
            >
              https://www.homedepot.com/c/Terms_of_Use
            </Link>
            .
          </Typography>
        </div>
      </DrawerBody>
    </Drawer>
  );
};
